var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import DataBox from '~/components/common/data-box.vue';
var RepaymentReceiveDetail = /** @class */ (function (_super) {
    __extends(RepaymentReceiveDetail, _super);
    function RepaymentReceiveDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        return _this;
    }
    RepaymentReceiveDetail.prototype.emitClose = function () { };
    RepaymentReceiveDetail.prototype.commit = function () {
        if (this.selectionList.length > 1)
            return this.$message.error('只能选择单条信息，请重新选择！');
        this.emitClose();
        if (this.selectionList.length) {
            var dataBox = this.$refs['data-box'];
            dataBox.$parent.$parent.$parent.fromData.receiveAcctname = this.selectionList[0].gatheringAccount;
            dataBox.$parent.$parent.$parent.fromData.receiveAcctno = this.selectionList[0].gatheringAccountNo;
        }
    };
    __decorate([
        Prop()
    ], RepaymentReceiveDetail.prototype, "dataSet", void 0);
    __decorate([
        Emit('close')
    ], RepaymentReceiveDetail.prototype, "emitClose", null);
    RepaymentReceiveDetail = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], RepaymentReceiveDetail);
    return RepaymentReceiveDetail;
}(Vue));
export default RepaymentReceiveDetail;
